import BpkCheckbox from '@skyscanner-internal/backpack-web/bpk-component-checkbox';
import {
  BpkStack,
  BpkSpacing,
  BpkVessel,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';
import { useSelector } from 'react-redux';

import { CHECK_SOURCE } from '../../helpers/constants/dataTypeConstants';
import { useDirectnessFilter } from '../../helpers/hooks/useDirectnessFilter';
import { useTranslation } from '../../helpers/hooks/useTranslation';
import { trackInteractionEvent } from '../../helpers/logging/trackInteractionEvent';
import { getPreferDirects, isPreferDirectsEnabled } from '../../selectors';

import type { State } from '../../selectors/types';

type Props = Readonly<{
  className: string;
  showCheckBox: boolean;
}>;

function Filter({ className, showCheckBox }: Props) {
  const translate = useTranslation();
  const { toggleFilter } = useDirectnessFilter();
  const filtering = useSelector((state: State) => getPreferDirects(state));
  const isEnabled = useSelector((state: State) =>
    isPreferDirectsEnabled(state),
  );
  const disabled = !isEnabled;
  const labelStringId = disabled
    ? 'directs_filter_none_label'
    : 'direct_flights';
  const label = translate(labelStringId);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    toggleFilter(event.target.checked, CHECK_SOURCE);
    trackInteractionEvent({
      name: 'Direct_Filter_Toggled',
    });
  };

  return (
    <BpkStack
      direction="row"
      justify="space-between"
      align="center"
      gap={BpkSpacing.None}
    >
      {showCheckBox && (
        <BpkVessel className={className}>
          <BpkCheckbox
            name="prefer-directs"
            data-testid="prefer-directs"
            onChange={handleChange}
            label={label}
            checked={filtering}
            disabled={disabled}
          />
        </BpkVessel>
      )}
    </BpkStack>
  );
}

export default Filter;
